<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 09:16:22
-->
<template>
    <div>
        <a-menu
            v-model:selectedKeys="state.selectedKeys"
            mode="inline"
            theme="light"
            :open-keys="state.openKeys"
            @openChange="onOpenChange"
        >
            <template v-for="item in list" :key="item.key">
                <template v-if="!item.children">
                    <router-link :to="item.link">
                        <a-menu-item :key="item.key">
                            <template #icon>
                                <component :is="$antIcons[item.icon]"></component>
                            </template>
                            {{ $t(`${item.title_lang}`) }}
                        </a-menu-item>
                    </router-link>
                </template>
                <template v-else>
                    <sub-menu :key="item.key" :menu-info="item"/>
                </template>
            </template>
        </a-menu>
    </div>
</template>

<script setup>
    import { ref, reactive, toRefs, computed, watch, onMounted } from 'vue';
    import { useRoute } from 'vue-router';
    import SubMenu from './SubMenu.vue';
    import Mock from '../mock.json';
    import { useStore } from '@/store/index.js';
    import { MenuApi } from '@/api/MenuApi.js';

    const store = useStore()
    const route = useRoute()
    const props = defineProps({
        isCollapsed:{
            type:Boolean
        }
    })
    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const filteredMockMenu = ref([])
    
    // 菜单高亮及展开
    const state = reactive({
        // rootSubmenuKeys: list.value.map(item=>item.name),
        openKeys: ['DataQuery','AdvancedFunction','Fault','SystemMTG'], //route.matched.length > 2? route.matched[route.matched.length - 1].path.split('/') : [],// 展开子级菜单项
        selectedKeys: [`${route.name}`],// 默认高亮菜单项
    })

    const onOpenChange = (val) => {
        // console.log(val,'vvvvvvv',route)
        // const latestOpenKey = val.find(key => state.openKeys.indexOf(key) === -1)
        // if (state.rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        //     state.openKeys = val
        // } else {
        //     state.openKeys = latestOpenKey ? [latestOpenKey] : []
        // } 
    }

    // 渲染菜单
    const list = computed(()=>{
        // console.log(store.menuList,'store.menuList')
        function getMenu(data,index){
            return data.map(item=>{
                if(item.children && item.children.length > 0){
                    item.children = getMenu(item.children,index + 1)
                }
                
                return { 
                    ...item,
                    key: item.name,
                    title: item && item.meta && item.meta.title,
                    title_lang: item && item.meta && item.meta.lang,
                    link:item.path,
                    icon: item && item.meta && item.meta.icon,
                }
            })
        }
        // return getMenu(Mock.data, 0) // 测试数据
        return getMenu(store.menuList, 0)
    })
    
    
    watch(
        ()=>route.path,
        ()=>{
            state.selectedKeys = [`${route.name}`]
            // state.openKeys = route.matched.length > 2? route.matched[route.matched.length - 1].path.split('/') : []
            // console.log(state.openKeys,'openKeys')
        }
    )


    onMounted(()=>{
        store.getMenuList()
    })


</script>

<style lang="scss" scoped>

::v-deep .ant-menu-root{
    padding: 0 0 250px 0 !important;
}

::v-deep .ant-menu-light.ant-menu-inline .ant-menu-item{
    color: #666;
}

::v-deep .ant-menu-light .ant-menu-item-selected{
    background-color: #1226aa;
    color: #fff !important;
}

</style>